import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

@Injectable()
export class AuthGaurd implements CanActivate {

    constructor(private auth: AngularFireAuth, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
      return Observable.from(this.auth.authState)
        .take(1)
        .map(state => !!state)
        .do(authenticated => {
      if 
        (!authenticated) this.router.navigate([ '/authentication/login' ]);

        else if(localStorage.getItem('courierapp_role') == "admin" && route.data['onlySuperAdmin'])
        {
          this.router.navigate([ 'error/404' ]);
        }

        /* else if(localStorage.getItem('courierapp_role') == "customer" || localStorage.getItem('courierapp_role') == "driver")
        {
          this.router.navigate([ '/authentication/login' ]);
        } */
        else if(localStorage.getItem('courierapp_role') == "driver" || localStorage.getItem('courierapp_role') == "supervisor" 
        || localStorage.getItem('courierapp_role') == "employee")
        {
          if(route.data['isDriverNotAllowed'])
          this.router.navigate([ 'error/405' ]);
        }
        else if(localStorage.getItem('courierapp_role') == "customer")
        {
          this.router.navigate([ 'error/405' ]);
        }
      })
    }
} 


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/auth.service.ts